import axios from "axios";
import {formatDate} from "../format-date";
import {cleanHeaders} from "../clean-headers";

const getReleases = async (params) => {
  const headers = cleanHeaders(params);

  try {
    const response = await axios.get(
      "https://music.videomite.tech/api/release",
      { headers }
    ).then((res) => res.data);

    return response.map((product) => ({
      ...product,
      createdTime: formatDate(product.createdTime),
    }));
  } catch (error) {
    console.log(error);
  }
};

export { getReleases };
